<template>
  <div>
    <div
      v-html="$t('language.intro').replace(/\n/g, '<br/>')"
      class="select-your-language"
    ></div>
    <b-row>
      <b-col cols="2" offset="2">
        <div class="circle">
          <img src="../assets/de.svg" @click="languageSelectHandler('de')" />
        </div>
      </b-col>
      <b-col cols="2">
        <div class="circle">
          <img src="../assets/fr.svg" @click="languageSelectHandler('fr')" />
        </div>
      </b-col>
      <b-col cols="2">
        <div class="circle">
          <img src="../assets/it.svg" @click="languageSelectHandler('it')" />
        </div>
      </b-col>
      <b-col cols="2">
        <div class="circle">
          <img src="../assets/en.svg" @click="languageSelectHandler('en')" />
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="mt-5 text-center">
        
          <h4>Visual Implicit Profiler (VIP)<sup>&reg;</sup></h4>
          by PSYfiers  
          
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  name: "FormLanguage",
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      data: this.value,
    }
  },
  methods: {
    languageSelectHandler(lang) {
      this.data.languageId = lang
      this.$i18n.locale = lang
      this.$emit("input", this.data)
      this.$emit("selected")
    },
  },
  watch: {
    value(val) {
      this.data = val ? val : {}
    },
  },
}
</script>
<style >
.select-your-language {
  font-size: 40px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 50px;
}
@media screen and (max-width: 1200px) {
  .select-your-language {
    font-size: 3.5vw;
    font-weight: bold;
    text-align: center;
    margin-bottom: 50px;
  }
}
.circle {
  padding: 6%;
  border-radius: 50%;
  background-color: white;
  border: 1px solid #666;
  cursor: pointer;
  text-align: center;
}
.circle img {
  width: 100%;
}
.circle:hover {
  border: 2px solid #666;
}
.circle:active {
  border: 3px solid #999;
}
</style>